import Row from '$tablet-app/src/app/components/Row';
import Text from '$tablet-app/src/app/components/Text';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import styled from 'styled-components/native';
import { MealPreferencesDialogView } from '../store/types';

interface Props {
  title?: string;
  icon?: IconProp;
  iconColor?: string;
  value?: string | number;
  color?: string;
  goTo?: MealPreferencesDialogView;
  onPress?: (view: MealPreferencesDialogView) => void;
}

const MealPlanPreferenceTile = (props: Props) => {
  const { title, icon, iconColor, value, color, goTo, onPress } = props;

  const handlePress = () => goTo !== undefined && onPress?.(goTo);

  return (
    <Container color={color || 'white'} onPress={handlePress}>
      <TopRow>
        {icon ? (
          <FontAwesomeIcon icon={icon} color={iconColor} size={24} />
        ) : null}
      </TopRow>

      <MidSpacer />

      <Body>
        {title ? <Title weight="semibold">{title}</Title> : null}

        <Row justifyContent="space-between" alignItems="center">
          <ValueText variant="h3" weight="semibold" numberOfLines={1}>
            {value || '--'}
          </ValueText>
          <FontAwesomeIcon icon="chevron-right" size={24} />
        </Row>
      </Body>
    </Container>
  );
};

const Container = styled.TouchableOpacity<{ color: string }>`
  flex: 1;
  height: 144px;
  border-radius: 20px;

  background-color: ${({ color }) => color};
`;

const TopRow = styled(Row)`
  padding: 12px 16px;
`;

const MidSpacer = styled.View`
  flex: 1;
`;

const Body = styled.View`
  padding: 12px 16px;
  gap: 4px;
`;

const Title = styled(Text)`
  opacity: 0.5;
`;

const ValueText = styled(Text)`
  overflow: hidden;
`

export default MealPlanPreferenceTile;
